var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "mds-label",
    {
      attrs: {
        "on-dark": _vm.onDark,
        size: _vm.size,
        optional: _vm.optional,
        "optional-text": _vm.optionalText,
        required: _vm.required,
        "required-text": _vm.requiredText,
        text: _vm.label,
        "hidden-label": _vm.hiddenLabel,
        for: _vm.inputId,
      },
    },
    [
      _vm._t("mds-microcopy-above", function () {
        return [
          _vm.microcopyAbove
            ? _c("mds-microcopy", {
                attrs: { size: _vm.size, "on-dark": _vm.onDark },
                domProps: { innerHTML: _vm._s(_vm.microcopyAbove) },
              })
            : _vm._e(),
        ]
      }),
      _vm._v(" "),
      _vm.password
        ? _c(
            "div",
            { class: _vm.$style["mds-input__password-wrapper"] },
            [
              _c(
                "input",
                _vm._g(
                  _vm._b(
                    {
                      class: [
                        _vm.$style["mds-input"],
                        _vm.classObject,
                        _vm.sizeClass,
                      ],
                      attrs: {
                        "aria-invalid": _vm.error,
                        "data-mds-version": _vm.version,
                        id: _vm.inputId,
                        required: _vm.required,
                        type: _vm.passwordInputType,
                      },
                    },
                    "input",
                    _vm.$attrs,
                    false
                  ),
                  _vm.inputListeners
                )
              ),
              _vm._v(" "),
              _c("mds-button", {
                class: _vm.$style["mds-input__password-button"],
                attrs: {
                  type: "button",
                  variation: "icon-only",
                  size: _vm.size,
                  icon: _vm.showPasswordIcon,
                  "on-dark": _vm.onDark,
                  text: _vm.showPasswordText,
                },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    _vm.isPassword = !_vm.isPassword
                  },
                },
              }),
            ],
            1
          )
        : _c(
            "input",
            _vm._g(
              _vm._b(
                {
                  class: [
                    _vm.$style["mds-input"],
                    _vm.classObject,
                    _vm.sizeClass,
                  ],
                  attrs: {
                    "aria-invalid": _vm.error,
                    "data-mds-version": _vm.version,
                    id: _vm.inputId,
                    required: _vm.required,
                  },
                },
                "input",
                _vm.$attrs,
                false
              ),
              _vm.inputListeners
            )
          ),
      _vm._v(" "),
      _vm.error
        ? _c(
            "div",
            {
              class: _vm.$style["mds-input__field-error-wrapper"],
              attrs: { role: "alert", "aria-live": "assertive" },
            },
            _vm._l(_vm.errorText, function (text, index) {
              return _c("mds-field-error", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.error,
                    expression: "error",
                  },
                ],
                key: index,
                attrs: { size: _vm.size, "on-dark": _vm.onDark },
                domProps: { innerHTML: _vm._s(text) },
              })
            }),
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._t("mds-microcopy-below", function () {
        return [
          _vm.microcopyBelow
            ? _c("mds-microcopy", {
                attrs: { size: _vm.size, "on-dark": _vm.onDark },
                domProps: { innerHTML: _vm._s(_vm.microcopyBelow) },
              })
            : _vm._e(),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }